import React, { useCallback, useEffect, useRef, useState } from 'react'
import {
  AppBar,
  Box,
  Container,
  IconButton,
  Slide,
  styled,
  Toolbar,
  Typography,
  useMediaQuery,
} from '@mui/material'
import lightTheme from '../../styles/theme/lightTheme'
import { SelectLangages } from '../inputs'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faEnvelope,
  faRightToBracket,
  faSquareUser,
} from '@fortawesome/pro-regular-svg-icons'
import {
  faLinkedinIn,
  faInstagram,
  faFacebook,
  faYoutube,
} from '@fortawesome/free-brands-svg-icons'
import {
  Link,
  NavLink,
  useLocation,
  useMatch,
  useNavigate,
} from 'react-router-dom'
import logo from '../../assets/images/logos/Logo_IT_Job_Board.png'
import {
  faChevronDown,
  faChevronUp,
  faUser,
  faBuilding,
} from '@fortawesome/pro-solid-svg-icons'
import { useTranslation } from 'react-i18next'
import { useTheme } from '@emotion/react'
import { BorderButton, WhiteButton } from '../buttons'
import { useDispatch, useSelector } from 'react-redux'
import { userLogout } from '../../store/slices/userAuthReducer'
import { ROLE_CANDIDAT, ROLE_ENTREPRISE } from '../../data'
import SelectPays from '../inputs/SelectPays'

const TopBar = styled(Box)(({ theme }) => ({
  display: 'none',
  height: 50,
  width: '100%',
  backgroundColor: lightTheme.palette.primary.b2,

  [theme.breakpoints.up('lg')]: {
    display: 'flex',
  },
}))

const CustomBox = styled(Box)({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'space-between',
})

const HeaderBar = styled(Box)(({ theme }) => ({
  height: 100,
  width: '100%',
  display: 'flex',
  alignItems: 'center',
  /* zIndex: 3,*/
  justifyContent: 'space-between',
}))

const MenuContainer = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'checked',
  name: 'MenuContainer',
})(({ theme, checked }) => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  position: 'relative',
  transition: 'all .8 ease-in-out',
  border: checked ? '1px solid' : 'none',
  borderRadius: '50%',
  width: 35,
  height: 25,
  cursor: 'pointer',

  '& .checkbox': {
    display: 'none',
  },

  '& .hamburger-lines': {
    display: 'flex',
    flexDirection: 'column',

    justifyContent: 'flex-end',
    alignItems: 'center',
    transition: 'all 500ms ease-in',

    position: 'relative',
    width: 35,
    height: 25,

    '& .line': {
      display: 'block',
      height: 4,
      /*width: "32px",*/
      background: theme.palette.primary.b2,

      position: 'absolute',
      transition: 'all 700ms ease-in-out',
    },

    '& .line1': {
      width: '70%',
      top: 0,
      right: 0,
    },
    '& .line2': {
      width: '100%',
      top: '11px',
    },
    '& .line3': {
      width: '70%',
      /*top: "25px",*/
      bottom: 0,
      right: 0,
    },
  },

  "& input[type='checkbox']:checked ~ .hamburger-lines": {
    justifyContent: 'space-between',
  },
  "& input[type='checkbox']:checked ~ .hamburger-lines .line": {
    backgroundColor: theme.palette.primary.b2,
  },

  "& input[type='checkbox']:checked ~ .hamburger-lines .line1": {
    transform: 'rotate(135deg)',
    top: '11px',
    width: '100%',
    transition: 'all 700ms ease-in-out',
  },
  "& input[type='checkbox']:checked ~ .hamburger-lines .line2": {
    transform: 'rotate(45deg)',
    top: '11px',
    width: '100%',
    transition: 'all 700ms ease-in-out',
  },
  "& input[type='checkbox']:checked ~ .hamburger-lines .line3": {
    width: 0,
  },

  [theme.breakpoints.up('lg')]: {
    display: 'none',
  },
}))

const ListContainer = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'activeLink',
  name: 'ListContainer',
})(({ theme, activeLink }) => ({
  display: 'flex',
  rowGap: '30px',
  columnGap: '30px',
  flexDirection: 'column',
  height: '100%',
  /*justifyContent: "space-between",*/
  justifyContent: 'center',
  alignItems: 'center',
  zIndex: 99,

  '.menu-items': {
    fontFamily: activeLink ? 'Century Gothic Bold' : 'Century Gothic',
    fontSize: 16,
    lineHeight: '140%',
    letterSpacing: '0.2px',
    color: activeLink
      ? lightTheme.palette.primary.main
      : lightTheme.palette.grey.dark,
    cursor: 'pointer',
    position: 'relative',
    listStyle: 'none',
    textAlign: 'center',

    button: {
      background: 'transparent',
      border: 'none',
      fontFamily: activeLink ? 'Century Gothic Bold' : 'Century Gothic',
      fontSize: 16,
      fontWeight: 'bold',
      lineHeight: '140%',
      letterSpacing: '0.2px',
      color: activeLink
        ? lightTheme.palette.primary.main
        : lightTheme.palette.grey.dark,
      cursor: 'pointer',
      boxShadow: 'none',

      '&:hover': {
        fontFamily: 'Century Gothic Bold',
        color: lightTheme.palette.primary.main,
      },
    },

    '&:hover': {
      fontFamily: 'Century Gothic Bold',
      color: lightTheme.palette.primary.main,
    },
  },

  '.dropdown': {
    display: 'none',
    position: 'absolute',
    top: '40px',
    left: '50%',
    margin: '0 auto',
    width: 250,
    height: 90,
    borderRadius: '10px',
    boxShadow: lightTheme.palette.shadow.dropdownShadow,
    flexDirection: 'column',
    justifyContent: 'space-around',
    alignItems: 'flex-start',
    paddingLeft: '20px',
    background: '#FFFFFF',
    transform: 'translate(-50%, 0)',

    '&.show': {
      display: 'flex',
    },
  },

  '.active': {
    color: lightTheme.palette.primary.main,
    fontFamily: 'Century Gothic Bold',
  },

  [theme.breakpoints.up('lg')]: {
    flexDirection: 'row',

    '.dropdown': {
      top: '75px',
      left: 'auto',
    },
  },
}))

function MenuLink({ label, to, activeOnlyWhenExact }) {
  let match = useMatch({
    path: to,
    exact: activeOnlyWhenExact,
  })

  return (
    <NavLink to={to} className={match ? 'active' : ''}>
      {label}
    </NavLink>
  )
}

const ImprovedMenuItems = () => {
  const [dropdown, setDropdown] = useState(false)
  let ref = useRef()
  const { t } = useTranslation()
  const navigate = useNavigate()

  useEffect(() => {
    const handler = (event) => {
      if (dropdown && ref.current && !ref.current.contains(event.target)) {
        setDropdown(false)
      }
    }
    document.addEventListener('mousedown', handler)
    document.addEventListener('touchstart', handler)
    return () => {
      document.removeEventListener('mousedown', handler)
      document.removeEventListener('touchstart', handler)
    }
  }, [dropdown])

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: '15px',
        flexDirection: { xs: 'column', lg: 'row' },
        width: { xs: '100%', lg: 'auto' },
      }}
    >
      {/* Commencer button with dropdown */}
      <Box
        ref={ref}
        sx={{
          position: 'relative',
          width: { xs: '100%', lg: 'auto' },
        }}
      >
        <BorderButton
          type={'rainbow'}
          textColor={'rainbow'}
          handleClick={() => setDropdown(!dropdown)}
          displayIconLeft={'none'}
          displayIconRight={'none'}
          icon={
            <FontAwesomeIcon icon={dropdown ? faChevronUp : faChevronDown} />
          }
          sx={{
            width: { xs: '100%', lg: 'auto' },
            justifyContent: { xs: 'space-between', lg: 'center' },
          }}
        >
          {t('header.start')}
        </BorderButton>

        <DropdownMenu dropdown={dropdown}>
          <DropdownItem onClick={() => navigate('/entreprises')}>
            <DropdownIcon className="dropdown-icon">
              <FontAwesomeIcon icon={faBuilding} />
            </DropdownIcon>
            <DropdownContent>
              <DropdownTitle>{t('header.company')}</DropdownTitle>
              <DropdownDescription>
                {t('header.publishOffer') || 'Publier une offre'}
              </DropdownDescription>
            </DropdownContent>
          </DropdownItem>
          <DropdownItem onClick={() => navigate('/candidats')}>
            <DropdownIcon className="dropdown-icon">
              <FontAwesomeIcon icon={faUser} />
            </DropdownIcon>
            <DropdownContent>
              <DropdownTitle>{t('header.candidate')}</DropdownTitle>
              <DropdownDescription>
                {t('header.findJob') || 'Trouver un emploi'}
              </DropdownDescription>
            </DropdownContent>
          </DropdownItem>
        </DropdownMenu>
      </Box>
    </Box>
  )
}

const DropdownMenu = styled(Box)(({ dropdown }) => ({
  position: 'absolute',
  top: '100%',
  left: 0,
  minWidth: '250px',
  backgroundColor: 'white',
  borderRadius: '8px',
  boxShadow: '0 4px 20px rgba(0, 0, 0, 0.15)',
  opacity: dropdown ? 1 : 0,
  visibility: dropdown ? 'visible' : 'hidden',
  transform: dropdown ? 'translateY(0)' : 'translateY(-10px)',
  transition: 'all 0.3s ease',
  zIndex: 1000,
  marginTop: '8px',

  // Mobile styles
  '@media (max-width: 1200px)': {
    position: 'absolute',
    top: 'auto',
    left: 'auto',
    minWidth: '100%',
    marginTop: '2px',
    boxShadow: 'none',
    borderRadius: '0',
    padding: '0',
    backgroundColor: 'transparent',
    opacity: dropdown ? 1 : 0,
    visibility: dropdown ? 'visible' : 'hidden',
    transform: dropdown ? 'translateY(0)' : 'translateY(-10px)',
  },
}))

const DropdownIcon = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  minWidth: '24px',
  marginRight: '12px',
  color: lightTheme.palette.primary.main,
  fontSize: '16px',
})

const DropdownContent = styled(Box)({
  flex: 1,
})

const DropdownItem = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  padding: '16px 20px',
  cursor: 'pointer',
  borderBottom: '1px solid #f0f0f0',
  transition: 'background-color 0.2s ease',
  '&:hover': {
    backgroundColor: '#f8f9fa',
    '& .dropdown-icon': {
      color: lightTheme.palette.primary.dark,
    },
  },
  '&:last-child': {
    borderBottom: 'none',
    borderRadius: '0 0 8px 8px',
  },

  // Mobile styles
  '@media (max-width: 1200px)': {
    padding: '10px',
    backgroundColor: 'rgba(255, 255, 255, 1)',
    borderRadius: '8px',
    marginBottom: '0px',
    borderRadius: '0px',
    border: `1px solid ${lightTheme.palette.primary.main}`,
    '&:hover': {
      transform: 'translateX(4px)',
    },
    '&:last-child': {
      borderTop: 'none',
      borderBottom: `1px solid ${lightTheme.palette.primary.main}`,
      marginBottom: '0',
    },
  },
})

const DropdownTitle = styled(Typography)({
  fontSize: '16px',
  fontWeight: 600,
  color: '#333',
  marginBottom: '4px',
})

const DropdownDescription = styled(Typography)({
  fontSize: '14px',
  color: '#666',
  lineHeight: 1.4,
})

const MenuItems = ({ items }) => {
  const [dropdown, setDropdown] = useState(false)
  let ref = useRef()

  useEffect(() => {
    const handler = (event) => {
      if (dropdown && ref.current && !ref.current.contains(event.target)) {
        setDropdown(false)
      }
    }
    document.addEventListener('mousedown', handler)
    document.addEventListener('touchstart', handler)
    return () => {
      // Cleanup the event listener
      document.removeEventListener('mousedown', handler)
      document.removeEventListener('touchstart', handler)
    }
  }, [dropdown])

  return (
    <li className="menu-items" ref={ref}>
      {items.submenu ? (
        <>
          <button
            type="button"
            aria-haspopup="menu"
            aria-expanded={dropdown ? 'true' : 'false'}
            onClick={() => setDropdown((prev) => !prev)}
            /*className={asPath === items.submenu ? "active" : ""}*/
          >
            {items.title} <FontAwesomeIcon icon={faChevronDown} />
          </button>
          <Dropdown submenus={items.submenu} dropdown={dropdown} />
        </>
      ) : (
        <MenuLink to={`${items.url}`} label={items.title} />
      )}
    </li>
  )
}

const Dropdown = ({ submenus, dropdown }) => {
  return (
    <ul className={`dropdown ${dropdown ? 'show' : ''}`}>
      {submenus.map((submenu, index) => (
        <li key={index} className="menu-items">
          <MenuLink to={submenu.url} label={submenu.title} />
        </li>
      ))}
    </ul>
  )
}

export default function AppNavBar() {
  const theme = useTheme()
  const { t } = useTranslation()
  const [checked, setChecked] = useState(false)
  const [activeLink, setActiveLink] = useState(0)
  const isLg = useMediaQuery(theme.breakpoints.up('lg'))
  const { pathname } = useLocation()
  const navigate = useNavigate()

  const user = useSelector((state) => state.userAuth.user)
  const dispatch = useDispatch()

  const menuItems = [
    {
      title: `${t('header.offers')}`,
      submenu: [
        {
          title: `${t('header.candidate')}`,
          url: '/candidats',
        },
        {
          title: `${t('header.company')}`,
          url: '/entreprises',
        },
      ],
    },
    /*{
        title: `${t('header.contents')}`,
        url: "/contenus",
    },
    {
        title: `${t('header.events')}`,
        url: "/evenements",
    },*/
  ]

  /* const menuUserItems = [
    {
      title: 'Contenus',
      url: '/contenus',
    },
    {
      title: 'Ateliers',
      url: '/ateliers',
    },
    {
      title: 'Candidat',
      url: '/candidat',
    },
    {
      title: 'Calendrier',
      submenu: [
        {
          title: 'Item 1',
          url: '/item1',
        },
        {
          title: 'Item 2',
          url: '/item2',
        },
      ],
    },
  ] */

  const handleClick = useCallback((i) => {
    setActiveLink(i)

    const anchor = document.querySelector(`#sec${i + 1}`)

    if (anchor) {
      anchor.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
        inline: 'nearest',
      })
    }
  }, [])

  const logout = () => {
    dispatch(userLogout())
    navigate('/')
  }

  return (
    <AppBar
      position={
        pathname === '/candidats' || pathname === '/entreprises'
          ? 'static'
          : 'sticky'
      }
      elevation={0}
      sx={{
        backgroundColor: '#FFFFFF',
        boxShadow: lightTheme.palette.shadow.headerShadow,
      }}
    >
      <TopBar>
        <Container maxWidth={'lg'}>
          <CustomBox>
            <Box
              sx={{
                display: 'flex',
                columnGap: '10px',
                alignItems: 'left',
              }}
            >
              {/* <SelectPays /> */}

              <SelectLangages />

              {/* <SelectDevise /> */}
            </Box>
            {user ? (
              <Box
                sx={{
                  display: 'flex',
                  columnGap: '20px',
                  alignItems: 'center',
                  marginLeft: 2,
                }}
              >
                <Typography variant={'body1'} color={'#FFFFFF'}>
                  {t('header.hello')} {user.data.prenom} {user.data.nom} !{' '}
                  {t('header.helloText')}
                </Typography>
                {/* <IconButton
                  type={"button"}
                  aria-label={"setting"}
                  sx={{padding: 0}}
                  onClick={() => navigate('/user/mon-profil')}
                >
                  <FontAwesomeIcon icon={faGear} style={{color: "#FFFFFF", fontSize: "15px"}}/>
                </IconButton> */}
                <IconButton
                  type={'button'}
                  aria-label={'logout'}
                  sx={{ padding: 0 }}
                  onClick={logout}
                  style={{ color: '#FFFFFF', fontSize: '15px' }}
                >
                  <FontAwesomeIcon
                    icon={faRightToBracket}
                    style={{
                      color: '#FFFFFF',
                      fontSize: '15px',
                      marginRight: '5px',
                    }}
                  />{' '}
                  <Typography variant={'body1'} color={'#FFFFFF'}>
                    {t('header.logout')}
                  </Typography>
                </IconButton>
              </Box>
            ) : (
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  columnGap: '50px',
                }}
              >
                {/* <Box
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    columnGap: '10px',
                  }}
                >
                  <FontAwesomeIcon icon={faEnvelope} />
                  <a href={'mailto:contact@jobertech.com'} rel={'noreferrer'}>
                    <Typography variant={'body1'} color={'#FFFFFF'}>
                      contact@jobertech.com
                    </Typography>
                  </a>
                </Box> */}
                {/* <Box
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    columnGap: '10px',
                  }}
                >
                  <Typography variant={'body1'} color={'#FFFFFF'}>
                    {t('header.follow')} !
                  </Typography>
                  <Box
                    sx={{
                      display: 'flex',
                      alignItems: 'center',
                      columnGap: '10px',
                    }}
                  >
                    <a
                      href={'https://www.linkedin.com/company/jobertechcorp/?'}
                      target={'_blank'}
                      rel={'noreferrer'}
                    >
                      <FontAwesomeIcon
                        icon={faLinkedinIn}
                        style={{ fontSize: 18 }}
                      />
                    </a>
                    <a
                      href={'https://www.instagram.com/jobertech/'}
                      target={'_blank'}
                      rel={'noreferrer'}
                    >
                      <FontAwesomeIcon
                        icon={faInstagram}
                        style={{ fontSize: 18 }}
                      />
                    </a>
                    <a
                      href={'https://az-az.facebook.com/JoberTech/'}
                      target={'_blank'}
                      rel={'noreferrer'}
                    >
                      <FontAwesomeIcon
                        icon={faFacebook}
                        style={{ fontSize: 18 }}
                      />
                    </a>
                    <a
                      href={'https://www.youtube.com/watch?v=0jC2LzB7vfY'}
                      target={'_blank'}
                      rel={'noreferrer'}
                    >
                      <FontAwesomeIcon
                        icon={faYoutube}
                        style={{ fontSize: 18 }}
                      />
                    </a>
                  </Box>
                </Box> */}
                <Link to={'/auth/se-connecter'}>
                  {t('header.login')} / {t('header.register')}
                </Link>
              </Box>
            )}
          </CustomBox>
        </Container>
      </TopBar>
      <Container
        maxWidth={'lg'}
        sx={{
          zIndex: 4,
          backgroundColor: '#FFFFFF',
        }}
      >
        <Toolbar disableGutters>
          <HeaderBar>
            <Link to={'/'}>
              <Box
                component={'img'}
                src={logo}
                alt={'Jobertech'}
                sx={{ width: { xs: 180, lg: '100%' } }}
              />
            </Link>
            <MenuContainer
              onClick={() => setChecked(!checked)}
              checked={checked}
            >
              <input
                className="checkbox"
                type="checkbox"
                name=""
                id=""
                checked={checked}
                onChange={() => setChecked(!checked)}
              />
              <div className="hamburger-lines">
                <span className="line line1" />
                <span className="line line2" />
                <span className="line line3" />
              </div>
            </MenuContainer>

            <Box
              sx={{
                display: { xs: 'none', lg: 'flex' },
                justifyContent: 'center',
                alignItems: 'center',
                columnGap: '10px',
              }}
            >
              <Box
                sx={{
                  display: { xs: 'none', lg: 'flex' },
                }}
              >
                {/* {!user && (
                <ListContainer>
                  <ImprovedMenuItems />
                </ListContainer>
              )} */}
                {!user && (
                  <>
                    <BorderButton
                      handleClick={() => navigate('/candidats')}
                      type={'rainbow'}
                      textColor={'rainbow'}
                      displayIconLeft={'none'}
                      displayIconRight={'none'}
                      sx={{
                        width: { xs: '100%', lg: 'auto' },
                        justifyContent: { xs: 'space-between', lg: 'center' },
                      }}
                    >
                      {t('header.candidate')}
                    </BorderButton>

                    <BorderButton
                      handleClick={() => navigate('/entreprises')}
                      type={'rainbow'}
                      textColor={'rainbow'}
                      displayIconLeft={'none'}
                      displayIconRight={'none'}
                      sx={{
                        width: { xs: '100%', lg: 'auto' },
                        justifyContent: { xs: 'space-between', lg: 'center' },
                      }}
                    >
                      {t('header.company')}
                    </BorderButton>
                  </>
                )}

                {user && user.data.role === ROLE_ENTREPRISE && (
                  <BorderButton
                    handleClick={() => navigate('/entreprises')}
                    type={'rainbow'}
                    textColor={'rainbow'}
                    displayIconLeft={'none'}
                    displayIconRight={'none'}
                    sx={{
                      width: { xs: '100%', lg: 'auto' },
                      justifyContent: { xs: 'space-between', lg: 'center' },
                    }}
                  >
                    {t('header.company')}
                  </BorderButton>
                )}

                {user && user.data.role === ROLE_CANDIDAT && (
                  <BorderButton
                    handleClick={() => navigate('/candidats')}
                    type={'rainbow'}
                    textColor={'rainbow'}
                    displayIconLeft={'none'}
                    displayIconRight={'none'}
                    sx={{
                      width: { xs: '100%', lg: 'auto' },
                      justifyContent: { xs: 'space-between', lg: 'center' },
                    }}
                  >
                    {t('header.candidate')}
                  </BorderButton>
                )}

                <BorderButton
                  displayIconLeft={'none'}
                  displayIconRight={'none'}
                  handleClick={() => navigate('/blog')}
                >
                  {t('footer.articles')}
                </BorderButton>
                <BorderButton
                  displayIconLeft={'none'}
                  displayIconRight={'none'}
                  handleClick={() => navigate('/ateliers')}
                >
                  {t('footer.workshops')}
                </BorderButton>
                {/*  {!user && ( */}
                {/* <ListContainer>
                {menuItems.map((menu, index) => {
                  return (
                    <MenuItems
                      items={menu}
                      key={index}
                      activeLink={activeLink}
                    />
                  )
                })}
              </ListContainer> */}
                {/* )} */}
                {false && user && user.data.role === ROLE_ENTREPRISE && (
                  <>
                    <BorderButton
                      displayIconLeft={'none'}
                      displayIconRight={'none'}
                      handleClick={() => navigate('/user/candidat/favoris')}
                    >
                      {t('header.favoris')}
                    </BorderButton>
                    <BorderButton
                      displayIconLeft={'none'}
                      displayIconRight={'none'}
                      handleClick={() => navigate('/user/candidats')}
                    >
                      {t('header.chtheque')}
                    </BorderButton>
                  </>
                )}
                {user && user.data.role === ROLE_CANDIDAT && (
                  <>
                    <BorderButton
                      displayIconLeft={'none'}
                      displayIconRight={'none'}
                      /* handleClick={() => navigate('/user/annonces')} */
                      handleClick={() => navigate('/offres-emploi')}
                    >
                      {t('header.annonces')}
                    </BorderButton>
                  </>
                )}
                {user ? (
                  <BorderButton
                    type={'rainbow'}
                    textColor={'rainbow'}
                    displayIconLeft={'none'}
                    displayIconRight={'flex'}
                    handleClick={() =>
                      user.data.role === ROLE_CANDIDAT ||
                      user.data.role === ROLE_ENTREPRISE
                        ? navigate('/user')
                        : navigate('/admin')
                    }
                    icon={
                      <FontAwesomeIcon
                        icon={faSquareUser}
                        style={{
                          background:
                            '-webkit-linear-gradient(#9c47fc, #356ad2)',
                          WebkitBackgroundClip: 'text',
                          textFillColor: 'transparent',
                          color: '#9c47fc',
                        }}
                      />
                    }
                  >
                    {t('header.myProfil')}
                  </BorderButton>
                ) : (
                  <></>
                )}
                {/* <BorderButton
                    type={'rainbow'}
                    textColor={'rainbow'}
                    displayIconLeft={'none'}
                    displayIconRight={'none'}
                    handleClick={() => navigate('/contact')}
                  >
                    {t('button.rdv')} 
                  </BorderButton> */}
              </Box>
            </Box>
          </HeaderBar>
        </Toolbar>
      </Container>

      {!isLg && (
        <Slide direction={'down'} in={checked} timeout={700}>
          <Box
            sx={{
              flexGrow: 1,
              display: { xs: 'flex', lg: 'flex' },
              flexDirection: 'column',
              alignItems: 'center',
              position: 'absolute',
              top: '100px',
              left: 0,
              width: '100%',
              height: { xs: 500, md: 580 },
              backgroundColor: '#FFFFFF',
              zIndex: 3,
              boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.05)',
            }}
          >
            <Box
              sx={{
                height: '100%',
                width: '100%',
              }}
            >
              <Container
                maxWidth={'lg'}
                sx={{
                  /* height: '100%', */
                  paddingTop: '30px',
                  paddingBottom: '30px',
                  display: 'flex',
                  flexDirection: 'column',
                  /*rowGap: "30px",*/
                }}
              >
                {user && (
                  <>
                    <BorderButton
                      type={'rainbow'}
                      textColor={'rainbow'}
                      displayIconLeft={'none'}
                      displayIconRight={'flex'}
                      handleClick={() => {
                        navigate('/user')
                        setChecked(!checked)
                      }}
                      icon={
                        <FontAwesomeIcon
                          icon={faSquareUser}
                          style={{
                            background:
                              '-webkit-linear-gradient(#9c47fc, #356ad2)',
                            WebkitBackgroundClip: 'text',
                            textFillColor: 'transparent',
                            color: '#9c47fc',
                          }}
                        />
                      }
                    >
                      {t('header.myProfil')}
                    </BorderButton>
                    <br></br>
                  </>
                )}
                {false && user && user.data.role === ROLE_ENTREPRISE && (
                  <>
                    <BorderButton
                      displayIconLeft={'none'}
                      displayIconRight={'none'}
                      handleClick={() => {
                        navigate('/user/candidat/favoris')
                        setChecked(!checked)
                      }}
                    >
                      {t('header.favoris')}
                    </BorderButton>
                    <br></br>
                    <BorderButton
                      displayIconLeft={'none'}
                      displayIconRight={'none'}
                      handleClick={() => {
                        navigate('/user/candidats')
                        setChecked(!checked)
                      }}
                    >
                      {t('header.chtheque')}
                    </BorderButton>
                    <br></br>
                  </>
                )}
                {/* <BorderButton
                  type={'rainbow'}
                  textColor={'rainbow'}
                  displayIconLeft={'none'}
                  displayIconRight={'none'}
                  handleClick={() => {
                    navigate('/contact')
                    setChecked(!checked)
                  }}
                >
                  {t('button.rdv')}
                </BorderButton>
                <br></br> */}

                {!user && (
                  <>
                    <BorderButton
                      handleClick={() => {
                        navigate('/candidats')
                        setChecked(!checked)
                      }}
                      type={'rainbow'}
                      textColor={'rainbow'}
                      displayIconLeft={'none'}
                      displayIconRight={'none'}
                      sx={{
                        width: { xs: '100%', lg: 'auto' },
                        justifyContent: { xs: 'space-between', lg: 'center' },
                      }}
                    >
                      {t('header.candidate')}
                    </BorderButton>
                    <br></br>
                    <BorderButton
                      handleClick={() => {
                        navigate('/entreprises')
                        setChecked(!checked)
                      }}
                      type={'rainbow'}
                      textColor={'rainbow'}
                      displayIconLeft={'none'}
                      displayIconRight={'none'}
                      sx={{
                        width: { xs: '100%', lg: 'auto' },
                        justifyContent: { xs: 'space-between', lg: 'center' },
                      }}
                    >
                      {t('header.company')}
                    </BorderButton>
                    <br></br>
                  </>
                )}

                <BorderButton
                  displayIconLeft={'none'}
                  displayIconRight={'none'}
                  handleClick={() => {
                    navigate('/blog')
                    setChecked(!checked)
                  }}
                >
                  {t('footer.articles')}
                </BorderButton>
                <br></br>
                <BorderButton
                  displayIconLeft={'none'}
                  displayIconRight={'none'}
                  handleClick={() => {
                    navigate('/ateliers')
                    setChecked(!checked)
                  }}
                >
                  {t('footer.workshops')}
                </BorderButton>

                {user && user.data.role === ROLE_ENTREPRISE && (
                  <>
                    <br></br>
                    <BorderButton
                      handleClick={() => {
                        navigate('/entreprises')
                        setChecked(!checked)
                      }}
                      type={'rainbow'}
                      textColor={'rainbow'}
                      displayIconLeft={'none'}
                      displayIconRight={'none'}
                      sx={{
                        width: { xs: '100%', lg: 'auto' },
                        justifyContent: { xs: 'space-between', lg: 'center' },
                      }}
                    >
                      {t('header.company')}
                    </BorderButton>
                  </>
                )}

                {user && user.data.role === ROLE_CANDIDAT && (
                  <>
                    <br></br>
                    <BorderButton
                      handleClick={() => {
                        navigate('/candidats')
                        setChecked(!checked)
                      }}
                      type={'rainbow'}
                      textColor={'rainbow'}
                      displayIconLeft={'none'}
                      displayIconRight={'none'}
                      sx={{
                        width: { xs: '100%', lg: 'auto' },
                        justifyContent: { xs: 'space-between', lg: 'center' },
                      }}
                    >
                      {t('header.candidate')}
                    </BorderButton>
                  </>
                )}
                {/* <ListContainer activeLink={activeLink}>
                  {menuItems.map((menu, i) => {
                    return (
                      <MenuItems
                        items={menu}
                        key={i}
                        activeLink={activeLink}
                        onClick={(e) => {
                          e.preventDefault()
                          handleClick(i)
                          setChecked(!checked)
                        }}
                      />
                    )
                  })}
                </ListContainer> */}
              </Container>
            </Box>
            <Box
              sx={{
                width: '100%',
                minHeight: 220,
                backgroundColor: lightTheme.palette.primary.b3,
              }}
            >
              <Container
                maxWidth={'lg'}
                sx={{
                  paddingTop: '25px',
                  paddingBottom: '25px',

                  height: '100%',
                }}
              >
                <Box
                  sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    rowGap: '25px',

                    height: '100%',
                    justifyContent: 'flex-end',
                  }}
                >
                  {user ? (
                    <>
                      <Box
                        sx={{
                          display: 'flex',
                          columnGap: '20px',
                          alignItems: 'center',
                          marginLeft: 2,
                        }}
                      >
                        <WhiteButton width={'100%'} handleClick={logout}>
                          {t('header.logout')}
                        </WhiteButton>
                      </Box>
                    </>
                  ) : (
                    <WhiteButton
                      width={'100%'}
                      handleClick={() => navigate('/auth/se-connecter')}
                    >
                      {t('header.login')}
                    </WhiteButton>
                  )}

                  <Box
                    sx={{
                      display: 'grid',
                      flexDirection: { xs: 'column', sm: 'row' },
                      /*rowGap: "30px",*/
                      rowGap: '10px',

                      /*gridTemplateColumns: { xs: "repeat(2, 1fr)", sm: "repeat(3, 1fr)"},
                      gridTemplateRows: { xs: "repeat(2, 1fr)", sm: "1fr"},*/
                      gridTemplateColumns: {
                        xs: 'repeat(1, 1fr)',
                        sm: 'repeat(3, 1fr)',
                      },
                      gridTemplateRows: { xs: 'repeat(2, 1fr)', sm: '1fr' },
                      justifyItems: 'center',

                      '.firstBloc': {
                        gridRowStart: 1,
                        gridColumnStart: 1,
                        gridColumnEnd: { xs: 3, sm: 2 },
                        width: '100%',
                      },
                      '.secondBloc': {
                        gridRowStart: { xs: 2, sm: 1 },
                      },
                      '.thirdBloc': {
                        /*gridRowStart: {xs: 2, sm: 1}*/
                        gridRowStart: { xs: 3, sm: 1 },
                      },
                    }}
                  >
                    <Box className="firstBloc">
                      {/* <Box
                        sx={{
                          display: 'table-cell',
                          columnGap: '20px',
                          alignItems: 'center',
                          width: '50%',
                          paddingRight: '20px',
                        }}
                      >
                        <SelectPays />
                      </Box> */}
                      <Box
                        sx={
                          {
                            /* display: 'table-cell', */
                            /* columnGap: '20px',
                          alignItems: 'right', */
                            /* width: '50%', */
                            /* paddingLeft: '40px', */
                          }
                        }
                      >
                        <SelectLangages />
                      </Box>
                    </Box>

                    <Box
                      sx={{
                        display: 'flex',
                        width: '100%',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                      }}
                    >
                      <CustomBox className="secondBloc">
                        <FontAwesomeIcon
                          icon={faEnvelope}
                          style={{ marginRight: '5px', color: '#FFFFFF' }}
                        />
                        <a href={'mailto:contact@jobertech.com'}>
                          <Typography variant={'body2'} color={'#FFFFFF'}>
                            contact@jobertech.com
                          </Typography>
                        </a>
                      </CustomBox>
                      <CustomBox
                        className="thirdBloc"
                        sx={{
                          columnGap: '10px',
                        }}
                      >
                        <Typography variant={'body2'} color={'#FFFFFF'}>
                          {t('header.follow')} !
                        </Typography>
                        <CustomBox
                          sx={{
                            columnGap: '5px',
                          }}
                        >
                          <a
                            href={
                              'https://www.linkedin.com/company/jobertechcorp/?'
                            }
                            target={'_blank'}
                            rel={'noreferrer'}
                          >
                            <FontAwesomeIcon
                              icon={faLinkedinIn}
                              style={{ fontSize: 15, color: '#FFFFFF' }}
                            />
                          </a>
                          <a
                            href={'https://www.instagram.com/jobertech/'}
                            target={'_blank'}
                            rel={'noreferrer'}
                          >
                            <FontAwesomeIcon
                              icon={faInstagram}
                              style={{ fontSize: 15, color: '#FFFFFF' }}
                            />
                          </a>
                          <a
                            href={'https://az-az.facebook.com/JoberTech/'}
                            target={'_blank'}
                            rel={'noreferrer'}
                          >
                            <FontAwesomeIcon
                              icon={faFacebook}
                              style={{ fontSize: 15, color: '#FFFFFF' }}
                            />
                          </a>
                          <a
                            href={'https://www.youtube.com/watch?v=0jC2LzB7vfY'}
                            target={'_blank'}
                            rel={'noreferrer'}
                          >
                            <FontAwesomeIcon
                              icon={faYoutube}
                              style={{
                                fontSize: 15,
                                color: lightTheme.palette.grey.dark,
                              }}
                            />
                          </a>
                        </CustomBox>
                      </CustomBox>
                    </Box>
                  </Box>
                </Box>
              </Container>
            </Box>
          </Box>
        </Slide>
      )}
    </AppBar>
  )
}
